import AddTagModal from './AddTagModal';

export default AddTagModal;
